import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { AdmissionPacketWorkspace } from "@/components/app/admission-packet/packet/workspace";

export const Route = createFileRoute(
  "/_authenticated/_care/residents/$residentId/admission-packets/$packetId",
)({
  component: ResidentAdmissionPacketWorkspace,
});

/** One resident's admission packet, from first question to last signature. */
function ResidentAdmissionPacketWorkspace() {
  const { residentId, packetId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <AdmissionPacketWorkspace
      key={packetId}
      packetId={packetId}
      onOpenPacket={(next) =>
        navigate({
          to: "/residents/$residentId/admission-packets/$packetId",
          params: { residentId, packetId: next },
        })
      }
      back={
        <Link
          to="/residents/$residentId/admission-packet"
          params={{ residentId }}
          className="hover:underline"
        >
          Back to the chart
        </Link>
      }
    />
  );
}
